import { Component }         from '@angular/core';
import { Platform }          from 'ionic-angular';
import { NavController }     from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { ToastController }   from 'ionic-angular';
import { TranslateService }  from '@ngx-translate/core';
import { AuthService }       from '../../shared/providers/auth-service';
import { ApplicationService } from '../../shared/providers/application-service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'page-create-account',
  templateUrl: 'create-account.html'
})
export class CreateAccountPage
{
  login           : string  = '';
  password        : string  = '';
  waitingLabel    : string        = "Please wait...";
  emailLabel    : string          = "Check your mailbox";

  constructor(public navCtrl:            NavController,
              public platform:           Platform,
              public loadingCtrl:        LoadingController,
              public toastCtrl:          ToastController,
              public translateService:   TranslateService,
              public appService:         ApplicationService,
              private authService:       AuthService)
  {
    platform.ready().then(() => {
      this.initTranslations();
    });
  }

  createAccount()
  {
    let loader  = this.presentLoading();
    loader.present();
    setTimeout(() =>
    {
      this.authService.createAccount(this.login, environment.RESET_PASS_URL).subscribe(
        user => {
          this.presentToast(this.emailLabel);
          loader.dismiss();
          this.navCtrl.pop({animate: false});
        },
        err => {
          loader.dismiss();
          this.presentToast( 'Not allowed');

        }
      );
    }, 1000);
  }

  presentLoading()
  {
     let loader = this.loadingCtrl.create({
       content: "Please wait..."
     });
     return loader;
  }

  presentToast(message)
  {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  initTranslations()
  {
    this.translateService.get('PLEASE_WAIT')
    .subscribe(
      value => {
        this.waitingLabel = value;
      }
    );
    this.translateService.get('CHECK_MAIL')
    .subscribe(
      value => {
        this.emailLabel = value;
      }
    );
  }

  backAction() : void
  {
    this.navCtrl.pop({animate: false});
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/create-account/create-account.ts